import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, Routes } from '@angular/router';
import { InformeRendimentosComponent } from './features/informe-rendimentos/informe-rendimentos.component';
import { AutenticacaoComponent } from './features/autenticacao/autenticacao.component';
import { AutenticacaoAbertaComponent } from './features/autenticacao-aberta/autenticacao-aberta.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { TokenVerifyComponent } from './core/components/token-verify/token-verify.component';

export const routes: Routes = [
    {
        path: '',
        component: TokenVerifyComponent,
    },
    { path: 'home', component: InformeRendimentosComponent },
    { path: 'Authentication', component: AutenticacaoComponent },
    { path: 'not-found', component: NotFoundComponent },
    { path: 'AuthenticationOpen', component: AutenticacaoAbertaComponent },
];
